// extracted by mini-css-extract-plugin
module.exports = {"info":"Info_info__260r-","number":"Info_number__19YmK","pulsate":"Info_pulsate__Y3m21"};